import { render, staticRenderFns } from "./SediContatti.vue?vue&type=template&id=825661b2&scoped=true&"
import script from "./SediContatti.vue?vue&type=script&lang=js&"
export * from "./SediContatti.vue?vue&type=script&lang=js&"
import style0 from "./SediContatti.vue?vue&type=style&index=0&id=825661b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825661b2",
  null
  
)

export default component.exports